import React from "react";

const FourthSection = () => {
  return (
    <div data-aos="fade-down-left"  className="mt-10 shadow-md shadow-slate-400 p-5">
      <h1 className="text-2xl text-primary font-semibold underline text-left">
        Large Scale Cultural Engineering:{" "}
      </h1>
      <p className="mt-2 text-lg font-medium text-slate-600 text-left">
        <span className="font-bold">
          Making Altruism Culturally High Status.
        </span>{" "}
        <br />
        <br />
        Ultimately, the more projects that promote this new line of thinking,
        the more people think others think this way, the more status will align
        culturally with its true nature. Watching others do good for the world
        has always given us more hope for humanity. We believe the flippening of
        status has the potential to solve the worlds greatest cause of poverty,
        the failed distribution of wealth worldwide. <br />
        <br />
        We don’t need to enforce rules where people are forced to give up their
        things, we need brands that invest in education for the masses to wake
        up to what real status/value is and place higher alternatives into the
        market. <br />
        <br />
        With the release of more and more globally disruptive technology,
        anxiousness about our focus on making sure things goes right becomes
        more apparent. By educating the world on alignment of using money and
        power for good from the most basic layer of apparel we will begin to
        cause this shift. With the right priming, a large amount of legacy
        wealth will be funneled into shifting the global workforce into focusing
        on the worlds greatest problems. <br />
      </p>
    </div>
  );
};

export default FourthSection;
